/**
 * Notification Management-specific translation keys
 */
export const notification = {
  list: {
    main_heading: "admin.notification_list_heading",
    table: {
      status_col_heading: "admin.notification_table_status_col_heading",
      title_col_heading: "admin.notification_table_title_col_heading",
      message_col_heading: "admin.notification_table_message_col_heading",
      type_col_heading: "admin.notification_table_type_col_heading",
      date_col_heading: "admin.notification_table_date_col_heading",
      actions_col_heading: "admin.notification_table_actions_col_heading",
    },
    status: {
      read: "admin.notification_status_read",
      unread: "admin.notification_status_unread",
    },
    filter: {
      placeholder: "admin.notification_filter_placeholder",
      all: "admin.notification_filter_all",
      unread: "admin.notification_filter_unread",
      read: "admin.notification_filter_read",
    },
    read_all_btn_text: "admin.notification_read_all_btn_text",
    delete_all_btn_text: "admin.notification_delete_all_btn_text",
    action_tooltip: {
      mark_read: "admin.notification_action_tooltip_mark_read",
    },
    delete_all_popup: {
      heading: "admin.notification_delete_all_popup_heading",
      message: "admin.notification_delete_all_popup_message",
      yes_btn_text: "admin.notification_delete_all_popup_yes_btn_text",
      no_btn_text: "admin.notification_delete_all_popup_no_btn_text",
    },
    messages: {
      fetch_failed: "admin.notification_messages_fetch_failed",
      read_success: "admin.notification_messages_read_success",
      read_all_success: "admin.notification_messages_read_all_success",
      delete_all_success: "admin.notification_messages_delete_all_success",
      delete_all_failed: "admin.notification_messages_delete_all_failed",
      no_notifications: "admin.notification_messages_no_notifications",
    },
    defaults: {
      na: "admin.notification_defaults_na",
    },
    type_label: {
      freelancerApplication: "admin.notification_type_freelancer_application",
      freelancerServiceUpdate: "admin.notification_type_freelancer_service_update",
      freelancerDocumentVerification: "admin.notification_type_freelancer_document_verification",
    },
  },
};
